import { api, BASE_URL, getToken } from './client';

export interface VmiDeclarationRowDto {
  rowNumber: number;
  personId: number;
  personCode: string;
  personName: string;
  income: number;
  tax: number;
  taxRate: number | null;
  extras?: Record<string, string> | null;
}

export interface VmiDeclarationDto {
  declarationType: string;
  year: number | null;
  month: number | null;
  dateFrom: string | null;
  dateTo: string | null;
  personCount: number;
  totalIncome: number;
  totalTax: number;
  rows: VmiDeclarationRowDto[];
  warnings: string[];
}

export interface VmiDeclarationSummaryDto {
  id: number;
  declarationType: string;
  year: number | null;
  month: number | null;
  dateFrom: string | null;
  dateTo: string | null;
  status: string;
  personCount: number;
  totalIncome: number;
  totalTax: number;
  generatedAt: string;
}

export const vmiApi = {
  generate: (type: string, year: number, month: number) =>
    api.post<VmiDeclarationDto>('/vmi-declarations/generate', { type, year, month }),

  generate312: (year: number) =>
    api.post<VmiDeclarationDto>('/vmi-declarations/generate', { type: 'GPM312', year }),

  save: (type: string, year: number, month: number) =>
    api.post<number>('/vmi-declarations/save', { type, year, month }),

  save312: (year: number) =>
    api.post<number>('/vmi-declarations/save', { type: 'GPM312', year }),

  generate0471: (from: string, to: string) =>
    api.post<VmiDeclarationDto>('/vmi-declarations/generate', { type: 'FR0471', from, to }),

  save0471: (from: string, to: string) =>
    api.post<number>('/vmi-declarations/save', { type: 'FR0471', from, to }),

  list: () => api.get<VmiDeclarationSummaryDto[]>('/vmi-declarations'),

  action: (id: number, action: 'submit' | 'approve' | 'lock' | 'reject', actor: string) =>
    api.post<void>(`/vmi-declarations/${id}/action`, { actor, action }),

  exportCsv: async (id: number): Promise<void> => {
    const headers: Record<string, string> = { Accept: 'text/csv' };
    const token = getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;
    const response = await fetch(`${BASE_URL}/vmi-declarations/${id}/export`, {
      headers,
      credentials: 'include',
    });
    if (!response.ok) throw new Error(`Eksportas nepavyko (${response.status})`);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    try {
      const a = document.createElement('a');
      a.href = url;
      a.download = `vmi-deklaracija-${id}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } finally {
      URL.revokeObjectURL(url);
    }
  },
};
